import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PBBTransactionResponse } from '../models/paybybank';

@Injectable({
  providedIn: 'root'
})
export class PaybybankService {
  paybybankUrl = environment.PAYMENT_UI + '/epms/paybybank';

  constructor(private http: HttpClient) { }

  httpHeaders = {
    headers:  new HttpHeaders({'Content-Type': 'application/json'})
  };

  capturePayByBankOrder(orderTranscationId: string, reqBody: PBBTransactionResponse): Promise<string> {
    return this.http.post<string>(
      this.paybybankUrl + '/capture/' + orderTranscationId,
      reqBody,
      { ...this.httpHeaders, withCredentials: true }  // ← ADD
    ).toPromise();
  }

  postPayByBankStubData(reqBody: any) {
    return this.http.post<any>(
      this.paybybankUrl + '/stub',
      reqBody,
      { ...this.httpHeaders, withCredentials: true }  // ← ADD
    ).toPromise();
  }
}
